import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DateRangeSelector = ({ onRangeChange, className = '' }) => {
  const [selectedRange, setSelectedRange] = useState('30d');
  const [isCustomOpen, setIsCustomOpen] = useState(false);

  const predefinedRanges = [
    { id: '7d', label: '7 Days', value: 7 },
    { id: '30d', label: '30 Days', value: 30 },
    { id: '90d', label: '90 Days', value: 90 },
    { id: '1y', label: '1 Year', value: 365 },
    { id: 'custom', label: 'Custom', value: null }
  ];

  const handleRangeSelect = (rangeId) => {
    setSelectedRange(rangeId);
    if (rangeId === 'custom') {
      setIsCustomOpen(true);
    } else {
      setIsCustomOpen(false);
      const range = predefinedRanges?.find(r => r?.id === rangeId);
      if (range && onRangeChange) {
        const endDate = new Date();
        const startDate = new Date();
        startDate?.setDate(endDate?.getDate() - range?.value);
        onRangeChange({ startDate, endDate, range: rangeId });
      }
    }
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getCurrentRange = () => {
    if (selectedRange === 'custom') return 'Custom Range';
    const range = predefinedRanges?.find(r => r?.id === selectedRange);
    return range ? `Last ${range?.label}` : 'Select Range';
  };

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      <div className="flex items-center space-x-2">
        <Icon name="Calendar" size={16} className="text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">Date Range:</span>
      </div>
      <div className="relative">
        <div className="flex items-center space-x-1 bg-card border border-border rounded-md">
          {predefinedRanges?.map((range) => (
            <button
              key={range?.id}
              onClick={() => handleRangeSelect(range?.id)}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-smooth ${
                selectedRange === range?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              {range?.label}
            </button>
          ))}
        </div>
        
        {isCustomOpen && (
          <div className="absolute top-full left-0 mt-2 p-4 bg-popover border border-border rounded-lg dropdown-shadow z-50 min-w-80">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Start Date
                </label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-border rounded-md bg-input text-foreground focus:ring-2 focus:ring-ring focus:border-transparent"
                  defaultValue={new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)?.toISOString()?.split('T')?.[0]}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  End Date
                </label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-border rounded-md bg-input text-foreground focus:ring-2 focus:ring-ring focus:border-transparent"
                  defaultValue={new Date()?.toISOString()?.split('T')?.[0]}
                />
              </div>
              <div className="flex items-center space-x-2">
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => {
                    setIsCustomOpen(false);
                    // Handle custom date range application
                  }}
                >
                  Apply
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setIsCustomOpen(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="text-sm text-muted-foreground">
        {getCurrentRange()}
      </div>
    </div>
  );
};

export default DateRangeSelector;